import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba224e7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-2-explainer" }, " Statements can now be printed and emailed: ", -1))
const _hoisted_2 = { class: "row-fields-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Print a copy of each Statement for your own files", -1))
const _hoisted_4 = { class: "controls-row" }
const _hoisted_5 = { class: "row-fields-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Print a copy of each Statement to post", -1))
const _hoisted_7 = { class: "controls-row" }
const _hoisted_8 = { class: "row-fields-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Produces Emails and attaches Statements as a PDF", -1))
const _hoisted_10 = { class: "controls-row" }

import { onMounted, PropType, ref } from "vue";
import DxButton from "devextreme-vue/button";
import AcquaintInfoBox from "@/components/ui/inputs/acquaint-info-box.vue";
import { SummaryStatementFormItem } from "@/types/financials/SummaryStatement";
import SummaryCustomPanel from "@/components/financials/summary-custom-panel.vue";
import { SummaryStatementPdfRequest } from "@/types/financials/SummaryStatementPdfRequest";
import { AccountItem } from "@/types/financials/AccountItem";
import { useFinancialHelper } from "@/utils/financials/useFinancialHelper";
import EmailFormModal from "@/components/email/email-form-modal.vue";
import { Templates } from "@/enums/constants/Templates";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";


export default /*#__PURE__*/_defineComponent({
  __name: 'summary-statement-step2',
  props: {
  /**
   * Form data object containing summary statement details to be edited or created.
   * @type {SummaryStatementFormItem}
   * @required true
   */
  formItem: {
    type: Object as PropType<SummaryStatementFormItem>,
    required: true,
  },
  /**
   * List of available account items for selection in the form.
   * @type {AccountItem[]}
   * @required true
   */
  accountItems: {
    type: Array as PropType<AccountItem[]>,
    required: true,
  },
  /**
   * Array of contact IDs for filtering or selection purposes.
   * @type {number[]}
   * @required true
   */
  contactIds: {
    type: Array as PropType<number[]>,
    required: true,
  },
  /**
   * Array of property IDs for filtering or selection purposes.
   * @type {number[]}
   * @required true
   */
  propertyIds: {
    type: Array as PropType<number[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



onMounted(async () => {
  currentUserDetails.value = await currentUserStore.getCurrentUserDetails();
});

const financialHelper = useFinancialHelper();
const currentUserStore = useCurrentUserStore();
const currentUserDetails = ref<CurrentUser>();
const displayEmailFormModal = ref(false);
const summaryStatementPdfRequest = ref<SummaryStatementPdfRequest>();

const onPrintFiling = async () => {
  summaryStatementPdfRequest.value = {
    bankAccountId: props.formItem.bankAccountId,
    allForFiling: true,
    startDate: props.formItem.startDate,
    endDate: props.formItem.endDate,
    accounts: props.accountItems,
  };
  await printStatements(summaryStatementPdfRequest.value);
};

const onPrintPosting = async () => {
  summaryStatementPdfRequest.value = {
    bankAccountId: props.formItem.bankAccountId,
    allForFiling: false,
    startDate: props.formItem.startDate,
    endDate: props.formItem.endDate,
    accounts: props.accountItems,
  };
  await printStatements(summaryStatementPdfRequest.value);
};

const onEmailProducing = () => {
  summaryStatementPdfRequest.value = {
    bankAccountId: props.formItem.bankAccountId,
    allForFiling: false,
    startDate: props.formItem.startDate,
    endDate: props.formItem.endDate,
    accounts: props.accountItems,
  };
  displayEmailFormModal.value = true;
};

const printStatements = async (request: SummaryStatementPdfRequest) => {
  const pdf = await financialHelper.generatePdfAllSummaryStatements(request);

  if (!pdf) {
    return;
  }

  // Create url
  const url = window.URL.createObjectURL(pdf);

  // Link allows us to download the pdf
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `account-summary-statment-${Date.now()}.pdf`);
  document.body.appendChild(link);
  link.click();

  // Clears memory
  link.remove();
  window.URL.revokeObjectURL(url);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createVNode(SummaryCustomPanel, {
        title: "Print for Filing",
        icon: "fa-regular fa-print"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(AcquaintInfoBox, {
                text: __props.formItem.statementsFilings.toString()
              }, null, 8, ["text"]),
              _createVNode(_unref(DxButton), {
                text: 'Print',
                type: !__props.formItem.enableButPrintForFiling ? 'normal' : 'default',
                "styling-mode": "contained",
                disabled: !__props.formItem.enableButPrintForFiling,
                onClick: onPrintFiling
              }, null, 8, ["type", "disabled"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(SummaryCustomPanel, {
        title: "Print for Posting",
        icon: "fa-regular fa-envelope"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(AcquaintInfoBox, {
                text: __props.formItem.statementsPostings.toString()
              }, null, 8, ["text"]),
              _createVNode(_unref(DxButton), {
                text: 'Print',
                type: !__props.formItem.enableButPrintForPosting ? 'normal' : 'default',
                "styling-mode": "contained",
                disabled: !__props.formItem.enableButPrintForPosting,
                onClick: onPrintPosting
              }, null, 8, ["type", "disabled"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(SummaryCustomPanel, {
        title: "Email",
        icon: "fa-regular fa-at"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(AcquaintInfoBox, {
                text: __props.formItem.statementsEmails.toString()
              }, null, 8, ["text"]),
              _createVNode(_unref(DxButton), {
                text: 'Email',
                type: !__props.formItem.enableButEmail ? 'normal' : 'default',
                "styling-mode": "contained",
                disabled: !__props.formItem.enableButEmail,
                onClick: onEmailProducing
              }, null, 8, ["type", "disabled"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(EmailFormModal, {
      modelValue: displayEmailFormModal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((displayEmailFormModal).value = $event)),
      emailTemplateId: _unref(Templates).PropertySummaryAccountStatementEmail,
      userId: currentUserDetails.value?.id,
      contactList: __props.contactIds,
      propertyRelatedToId: __props.propertyIds,
      summaryStatementRequest: summaryStatementPdfRequest.value
    }, null, 8, ["modelValue", "emailTemplateId", "userId", "contactList", "propertyRelatedToId", "summaryStatementRequest"])
  ], 64))
}
}

})